import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const trialStatusService = createApi({
  reducerPath: "trialStatus",
  baseQuery: fetchBaseQuery({ baseUrl: "/api" }),
  endpoints: (builder) => ({
    getTrialStatus: builder.query({
      query: (userId) => ({
        url: `/users/trial-status/${userId}`,
        method: "GET",
      }),
    }),
    updateTrialStatus: builder.mutation({
      query: (data) => ({
        url: `/users/trial-status`,
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const { useGetTrialStatusQuery, useUpdateTrialStatusMutation } = trialStatusService;
